export const IS_AUTHENTICATED = 'IS_AUTHENTICATED'
export const AUTHENTICATED_USER_INFO = 'AUTHENTICATED_USER_INFO'
export const IS_NOT_AUTHENTICATED = 'IS_NOT_AUTHENTICATED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILED = 'LOGIN_FAILED'
export const LOGOUT = 'LOGOUT'
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const CHECK_AUTHENTICATION = 'CHECK_AUTHENTICATION'
